$(document).ready(function() {
    // $('.productitem--swatches-container label:first-child input').prop('checked', true);
    var productContainer = $('.productitem__container')
    productContainer.each(function() {
        var isDisable = $(this).find('.productitem--swatches-container label:first-child input').hasClass('swatch-disabled')
        if(!isDisable) {
            $(this).find('.productitem--swatches-container label:first-child input').prop('checked', true)
        }
        var firstPrice = $(this).find('.productitem--swatches-container label:first-child input').attr('data-variant-price')
        $(this).find('.productitem--info .price__current').text(firstPrice)
    })

    $('body').on('click', 'input[type="radio"].productitem--swatches-input', function() {
        var product = $(this).closest('.productitem__container')
        var id = $(this).attr('data-variant-id')
        var price = $(this).attr('data-variant-price')
        product.find('.productitem--actions .productitem--action-trigger').attr('data-variant-id', id)
        product.find('.price__current').text(price)
    })
    // Prev Nex button on Featured Collection
    $("body").on('click', '.prev-button', function() {
        $(".flickity-button.previous").trigger('click')
    })
    $("body").on('click', '.next-button', function() {
        $(".flickity-button.next").trigger('click')
    })
    // Hide Next Prev button
    setInterval(function() {
        checkAndHideNextPrev()
    }, 100)
    function checkAndHideNextPrev() {
        var featuredCollection = $('.featured-collection__container ')
        featuredCollection.each(function(item) {
            if($(this).find('.home-section--content.is-draggable').length === 0) {
                $(this).find('.splide-button').css('display', 'none')
            } else {
                $(this).find('.splide-button').css('display', 'flex')
            }
        })
    }
    // Move recharge app
    if ($(window).width() < 575) {
        $(".product-form--regular").detach().appendTo(".mobile-third-column")
    }
})